// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1pDOF","errors":"Errors_errors__3JEWQ"};